/**************************************************
 * Nombre:       Dialogo_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {Delete} from "@mui/icons-material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";
import Formulario_Anuncios from "../Formularios/Formulario_Anuncios";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";

const Dialogo_Anuncios = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga()
        let imgDox = await subirImagenHostingFile(entidad.img)
        entidad.img = imgDox.data

        let imgDoxCell = await subirImagenHostingFile(entidad.imgCell)
        entidad.imgCell = imgDoxCell.data


        guardarFechaAct('anuncios')
        let dox = await guardarDoc('anuncios', entidad)
        if (dox.res) {
            await guardarFecha()
            terminar({aviso: 'Datos subidos'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }


    const borrar = async () => {
        await borrarDoc('anuncios', datos.id)
        terminar({aviso: 'Anuncios borrada'})
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Anuncios props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Anuncios